"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavigationArrowHeight = void 0;
var _constants = require("../constants");
var _getDotSize = require("./getDotSize");
/**
 * Decides `height` of navigation button based on `navigation.height`, `pagination.position`, `isMobile` and `theme`.
 *
 * @param param0 object containing `navigation`, `pagination`, `isMobile` and `theme` attributes.
 * @returns `height` of navigation button.
 */
const getNavigationArrowHeight = ({
  navigationHeight,
  paginationPosition,
  isMobile,
  theme
}) => {
  if (paginationPosition === 'inside') {
    return navigationHeight;
  }
  return `calc(100% - ${(0, _getDotSize.getDotSize)({
    isActive: true
  })} - ${theme.spacing(isMobile ? _constants.PAGINATION_MOBILE_MARGIN : _constants.PAGINATION_DESKTOP_MARGIN)})`;
};
exports.getNavigationArrowHeight = getNavigationArrowHeight;
//# sourceMappingURL=getNavigationArrowHeight.js.map